<!--
---
--- Custom v-text-field  which supports validation and localization
-->
<template>
    <v-text-field :name=name
                  :label="$t('attributes.'+name)"
                  :readonly="readonly"
                  v-model=model[name]
                  :placeholder="placeholder"
                  :error-messages="fieldErrors()"/>

</template>

<script>
    import '@/services/CustomValidations'

    export default {
        name: "my-input",

        props: {
            name: String,
            model: Object,
            placeholder: String,
            readonly : {
                type: Boolean,
                default: false
            }

        },

        $_veeValidate: {
            name() {
                return this.name;
            },
            value() {
                return this.model[this.name];
            }
        },

        methods: {
            // errors.collect is not working so we use the following work around to extract the
            // errors for this field
            fieldErrors() {
                var result = [];
                if (this.errors) {
                    for (const error of this.errors) {
                        if (error.field == this.name) {
                            result.push(error.msg)
                        }
                    }
                }
                return result;
            }
        }
    }
</script>